import { z } from 'zod';

const participantSchema = z.object({
  nom: z.string(),
  prenom: z.string(),
  mail: z.string(),
  fonction: z.string(),
  organisme: z.string(),
  present: z.boolean(),
});

export const meetingConveneValidateSchema = z.object({
  participants: z
    .array(participantSchema)
    .nonempty(' Veuillez sélectionner au moins un participant')
    .refine((participants: any[]) => participants.some(participant => participant.present), {
      message: 'Veuillez sélectionner au moins un participant présent',
      path: ['participants'],
    }),
  reunionPpms: z.array(
    z.object({
      decision: z.string().nonempty('La décision est obligatoire pour chaque PPM.'),
      observation: z.string().nullable().optional(),
    })
  ),
  reunionDacs: z.array(
    z.object({
      decision: z.string().nonempty('La décision est obligatoire pour chaque DAC.'),
      observation: z.string().nullable().optional(),
    })
  ),
  reunionReports: z.array(
    z.object({
      decision: z.string().nonempty('La décision est obligatoire pour chaque Report.'),
      observation: z.string().nullable().optional(),
    })
  ),
});
